import {_} from '../utils.js'

class TriggerTooltip {
    constructor(el) {
        el.addEventListener('click', this.triggerClick)
        this.url = el.dataset.url ?? false
        this.newWindow = el.dataset.newWindow ?? false
    }

    triggerClick = (e) => {
        e.preventDefault()
        if (this.url) {
            if (this.newWindow === 'true' || this.newWindow === true) {
                let a = document.createElement('a')
                a.target = '_blank'
                a.href = this.url
                a.click()
            } else {
                return (window.location.href = this.url)
            }
        } else {
            const target = e.currentTarget.dataset.for
            const tooltip = _(target, 'target').node()
            tooltip.dispatchEvent(new Event('click'))
        }
    }
}

export default TriggerTooltip
